import { render, staticRenderFns } from "./Badge2.vue?vue&type=template&id=13348db4&scoped=true"
import script from "./Badge2.vue?vue&type=script&lang=js"
export * from "./Badge2.vue?vue&type=script&lang=js"
import style0 from "./Badge2.vue?vue&type=style&index=0&id=13348db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13348db4",
  null
  
)

export default component.exports